<template>
    <div class="container-fluid">
        <div class="d-flex justify-content-between pt-3">
            <img src="../assets/bg-vita-logo.png" class="object-fit-contain" height="36" alt="">
            <div v-if="curScreen != 'StartScreenId'">
                <img src="../assets/bg-insieme-logo.png" class="object-fit-contain" height="55" alt="">
            </div>
            <img src="../assets/bg-private-logo.png" class="object-fit-contain" height="55" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        props: {
            curScreen: String
        }
    }
</script>